<template>
    <div id="wrapper">
        <div class="page-wrapper">
            <Header></Header>

            <!-- Login -->
            <div class="block container" style="padding: 20px;">
                <Loading :is-loading="loading"></Loading>
                <div class="row row-eq-height">
                    <div class="col-sm-6" style="margin: 0 auto">
                        <div class="form-card">
                            <h4>Only for Registered customers</h4>

                            <ValidationObserver v-slot="{ invalid, passes }">
                                <form @submit.prevent="passes(login)">
                                    <div class="form-group">
                                        <ValidationProvider rules="required|email" v-slot="{ errors }" name="email">
                                            <input v-model="email" type="text" class="form-control" placeholder="Email">
                                            <span style="color: red">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>

                                    <div class="form-group">
                                        <ValidationProvider rules="required" v-slot="{ errors }" name="Password">
                                            <input v-model="password" type="password" class="form-control" placeholder="Password">
                                            <span style="color: red">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>

                                    <button :disabled="invalid" class="btn"> Login</button>
                                </form>
                            </ValidationObserver>
                        </div>
                    </div>
                </div>

                <div v-if="error" style="text-align: center;padding: 20px;border-bottom: 1px solid red;">
                    {{ error }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../layouts/Header'
import Loading from '../../mixins/components/Loading'

export default {
    name: "Login",
    components: {
        Header, Loading
    },
    data () {
        return {
            message: null,
            error: null,
            remember: true,
            loading: false,
            email: null,
            password: null
        }
    },
    mounted () {
        this.redirectIfAuthenticated('Welcome')
    },
    methods: {
        login() {
            this.$swal({
                title: 'Are you a Human?',
                text: "Or a machine?",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Human',
                focusCancel: true,
                showLoaderOnConfirm: true,
                allowOutsideClick: () => !this.$swal.isLoading(),
                preConfirm: (login) => {
                    return this.$recaptcha('login').then((token) => {
                        if (token)
                            return token

                        console.log('Machine detection error!')
                    })
                }
            }).then((result) => {
                if (result.value) {
                    this.$swal("Success", "Login verified!", "success").then((result) => {
                        this.loading = true
                        this.message = this.error = null

                        this.$auth.login({
                            data: {
                                email: this.email,
                                password: this.password
                            },
                            rememberMe: this.remember
                        }).then(r => {
                            this.loading = false
                            this.message = r.data.message

                            if (typeof (status = r.data.status) !== 'undefined') {
                                // show alert
                                console.log(this.message, status)
                            }

                        }, e => {
                            this.loading = false
                            // show alert error
                            this.error = 'Error: Invalid login credentials!'
                        })
                    })
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/auth/Login.vue